import { ReadonlyRecord } from '@bimser/core';
import { List, Record } from 'immutable';
import {
	ILoadFilterGroup,
	LoadFilterGroup,
	LoadFilterGroupFactoryFromJS
} from './ILoadFilterGroup';
import { ILoadFilterItem, LoadFilterItem, LoadFilterItemFactoryFromJS } from './ILoadFilterItem';
import { IPagination, Pagination, PaginationFactory, PaginationFactoryFromJS } from './IPagination';
import { ISort, Sort, SortFactoryFromJS } from './ISort';

export interface IBaseLoadOptions {
	distinct?: boolean;
	filterNulls?: boolean;
	valueExpr?: string;
}

export interface ILoadOptions extends IBaseLoadOptions {
	filters: Array<ILoadFilterItem | ILoadFilterGroup>;
	sorts: Array<ISort>;
	pagination: IPagination;
}

export interface IReadonlyLoadOptions extends IBaseLoadOptions {
	filters: List<LoadFilterItem | LoadFilterGroup>;
	pagination: Pagination;
	sorts: List<Sort>;
}

export type LoadOptions = ReadonlyRecord<IReadonlyLoadOptions>;

export const LoadOptionsFactory = Record<IReadonlyLoadOptions>({
	filters: List(),
	pagination: PaginationFactory(),
	sorts: List(),
	distinct: null,
	filterNulls: null
});

export const LoadOptionsFactoryFromJS = function (data: ILoadOptions) {
	return LoadOptionsFactory({
		filters: data.filters?.map((d: ILoadFilterItem | ILoadFilterGroup) =>
			(d as ILoadFilterItem)?.Column
				? LoadFilterItemFactoryFromJS(d as ILoadFilterItem)
				: LoadFilterGroupFactoryFromJS(d as ILoadFilterGroup)
		) as any,
		pagination: PaginationFactoryFromJS(data.pagination),
		sorts: List(data?.sorts?.map(i => SortFactoryFromJS(i))),
		distinct: data.distinct,
		filterNulls: data.filterNulls
	});
};
